/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, useEffect, useState } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";

import languageContent from "./config/languageContent";
import Results from "./model/Results";
import Table from "react-bootstrap/esm/Table";
import TableHeader from "./components/TableHeader";
import ResultsManager from "./model/ResultsManager";

const webCrowdsServer = "http://vhlab.lad.pucrs.br:5000/runSim";

let language = 0; // English = 0 / Portuguese = 1
let bestResult = 0.0;

let isRunning = false;

const ImageBase64 = ({ data }: any) => (
  <img className="centerImage image" src={`data:image/jpeg;base64,${data}`} />
);

function App() {
  const [requested, setRequested] = useState<boolean>(false);
  // const [isRunning, setIsRunning] = useState<boolean>(false);
  const [unitySize, setUnitySize] = useState<string>("unity-full-width");
  const [haveData, setHaveData] = useState<boolean>(false);
  const [serverInternalError, setServerInternalError] =
    useState<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [results, setResults] = useState<ResultsManager>(new ResultsManager());

  const [currentSimulation, setCurrentSimulation] = useState<number>(0);
  const [totalSimulations, setTotalSimulations] = useState<number>(0);

  const {
    unityProvider,
    sendMessage,
    addEventListener,
    removeEventListener,
    loadingProgression,
    isLoaded,
  } = useUnityContext({
    productName: "BioCrowds",
    companyName: "",
    loaderUrl: "unitybuild/Build.loader.js",
    dataUrl: "unitybuild/Build.data",
    frameworkUrl: "unitybuild/Build.framework.js",
    codeUrl: "unitybuild/Build.wasm",
    streamingAssetsUrl: "unitybuild/streamingassets",
    webglContextAttributes: {
      preserveDrawingBuffer: true,
    },
  });

  useEffect(() => {
    addEventListener("RunScene", handleRunScene);

    return () => {
      removeEventListener("RunScene", handleRunScene);
    };
  }, [addEventListener, removeEventListener]);

  async function handleRunScene(message: string): Promise<void> {
    if (isRunning) {
      alert(languageContent()[language].errorAlreadySimulating);
      return;
    }
    setUnitySize("unity-half-width");
    setHaveData(false);
    setRequested(true);
    setServerInternalError(false);

    results.resetResults();
    bestResult = 0.0;
    isRunning = true;

    let unityData = JSON.parse(message);
    let unityScenarios = unityData["scenarios"];

    // console.log(unityScenarios);

    setTotalSimulations(parseInt(unityScenarios.length));

    for (let i: number = 0; i < unityScenarios.length; i++) {
      try {
        setCurrentSimulation(i + 1);

        // console.log("Running Sim " + (i + 1));

        let response = await axios.post(webCrowdsServer, {
          ...unityScenarios[i],
          simId: i + 1,
        });

        const data = JSON.parse(response.data)[1];

        let simulation: Results = new Results(
          (i + 1).toString(),
          unityScenarios[i].isCassolValid,
          data[0] /* heatmap */,
          data[1] /* trajectories */,
          data[2] /* simulationTime */,
          data[4] /* averageDistanceWalked */,
          data[6] /* averageSpeed */,
          data[7] /* averageFrameDensity */,
          data[8] /* averageSimulationTime */,
          data[9] /* newMetric */,
          data[10] /* cassolMetric */
        );

        if (
          parseFloat(simulation.getNewMetric()) < bestResult ||
          bestResult === 0.0
        ) {
          bestResult = parseFloat(simulation.getNewMetric());
        }

        results.addResult(simulation);

        console.log(simulation);
      } catch (error) {
        setTimeout(() => {
          updateRequestStatusInUnity();
        });
        setServerInternalError(true);
        setHaveData(false);
        isRunning = false;
        return;
      }
    }

    console.log(results);

    setTimeout(() => {
      updateRequestStatusInUnity();
    });

    setHaveData(true);
    isRunning = false;
  }

  function maximizeUnity() {
    setUnitySize("unity-full-width");
    setRequested(false);
    setHaveData(false);
  }

  function updateRequestStatusInUnity(): void {
    sendMessage("LevelEditorUIController", "SimulationFinishedRunning", "");
  }

  return (
    <Fragment>
      <div className="wrapper">
        <div className="unity-container">
          <Unity
            style={{ visibility: isLoaded ? "visible" : "hidden" }}
            className={"unity-canvas " + unitySize}
            unityProvider={unityProvider}
          />
          {!isLoaded && (
            <>
              <h3 className="loading">{languageContent()[language].loading}</h3>
              <p className="loading">
                {languageContent()[language].loadingProgress}
                {": "}
                {Math.round(loadingProgression * 100)}%
              </p>
            </>
          )}
        </div>
        {(haveData || requested) && (
          <div className="right-side">
            {requested && !haveData && !serverInternalError && (
              <div>
                <h3 className="simulation centerText">
                  {languageContent()
                    [language].simulationRunningPOne.replace(
                      "$1",
                      currentSimulation.toString()
                    )
                    .replace("$2", totalSimulations.toString())}
                  <br />
                  {languageContent()[language].simulationRunningPTwo}
                </h3>
              </div>
            )}
            {haveData && (
              <>
                <button
                  onClick={() => {
                    maximizeUnity();
                  }}
                  className="unity-button"
                >
                  {languageContent()[language].maximizeButton}
                </button>
                <div className="results">
                  <h3 className="simulation">
                    {languageContent()[language].informationSimulation}
                  </h3>
                  {/* Table */}
                  <Table striped>
                    <thead>
                      <TableHeader
                        showCassol={results.getResults()[0].canShowCassol()}
                      />
                    </thead>
                    <tbody>
                      {results.getResults().map((result) => {
                        if (!result.canShowCassol()) {
                          return (
                            <tr key={result.getSimIndex()}>
                              <td>{result.getSimIndex()}</td>
                              <td>{result.getSimulationTime()} s</td>
                              <td>{result.getAverageDistanceWalked()} m</td>
                              <td>{result.getAverageVelocity()} m/s</td>
                              <td>{result.getAverageDensity()}</td>
                              <td>{result.getAverageTime()} s</td>
                            </tr>
                          );
                        } else if (
                          parseFloat(result.getNewMetric()) === bestResult
                        ) {
                          return (
                            <>
                              <tr className="table-success">
                                <td>{result.getSimIndex()}</td>
                                <td>{result.getSimulationTime()} s</td>
                                <td>{result.getAverageDistanceWalked()} m</td>
                                <td>{result.getAverageVelocity()} m/s</td>
                                <td>{result.getAverageDensity()}</td>
                                <td>{result.getAverageTime()} s</td>
                                <td>{result.getNewMetric()}</td>
                                <td>{result.getCassol()}</td>
                              </tr>
                            </>
                          );
                        } else {
                          return (
                            <>
                              <tr key={result.getSimIndex()}>
                                <td>{result.getSimIndex()}</td>
                                <td>{result.getSimulationTime()} s</td>
                                <td>{result.getAverageDistanceWalked()} m</td>
                                <td>{result.getAverageVelocity()} m/s</td>
                                <td>{result.getAverageDensity()}</td>
                                <td>{result.getAverageTime()} s</td>
                                <td>{result.getNewMetric()}</td>
                                <td>{result.getCassol()}</td>
                              </tr>
                            </>
                          );
                        }
                      })}
                    </tbody>
                  </Table>
                  {/* HeatMap */}
                  <Container>
                    <Row xs={2} md={2}>
                      {results.getResults().map((result) => (
                        <Col>
                          <ImageBase64 data={result.getHeatmap()} />
                        </Col>
                      ))}
                    </Row>
                  </Container>
                  {/* Trajectory */}
                  <Container>
                    <Row xs={2} md={2}>
                      {results.getResults().map((result) => (
                        <Col>
                          <ImageBase64 data={result.getTrajectory()} />
                        </Col>
                      ))}
                    </Row>
                  </Container>
                </div>
              </>
            )}
            {serverInternalError && (
              <>
                <h4 className="internalerror">
                  {languageContent()[language].serverInternalError}
                </h4>
              </>
            )}
          </div>
        )}
      </div>
    </Fragment>
  );
}

export default App;
